import { Component, inject } from '@angular/core';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { ClientsService } from '@app/pages/clients/services/clients.service';
import { environment } from '@env/environment.local';

@Component({
  template: ""
})
export class StandardClientsViewWrapperComponent {
  public readonly clientsService = inject(ClientsService);
  private readonly quoteService = inject(StandardQuoteService);
  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;

  customer: any | undefined = this.quoteService.formData?.customer;

  getTypeCustomer(personType: string | undefined): string {
    if (personType == 'LEGAL_PERSON') {
      return 'Persona moral';
    } else if (personType == 'NATURAL_PERSON') {
      return 'Persona física';
    }
    return '';
  }

  get personType() {
    return this.customer?.personType;
  }

  private get resolvedNaturalPersonNames() {
    if (this.customer?.personType !== 'NATURAL_PERSON') {
      return null;
    }
    return this.clientsService.resolveNaturalPersonNameFields(this.customer);
  }

  get name() {
    if (this.customer?.personType === 'LEGAL_PERSON') {
      return this.customer?.customerName || this.customer?.firstName || '';
    }
    return this.resolvedNaturalPersonNames?.firstName ?? '';
  }

  get lastName() {
    return this.resolvedNaturalPersonNames?.lastName ?? this.customer?.lastName ?? '';
  }

  get mothersLastName() {
    return (
      this.resolvedNaturalPersonNames?.mothersLastName ??
      this.customer?.mothersLastName ??
      ''
    );
  }

  get rfc() {
    return this.customer?.rfc || '';
  }

  /** Solo lectura: `feriaCustomer` del cliente en la cotización. */
  customerFeriaReadonlyYesNo(): string {
    if (!this.featureLoyaltyFeriaQuotation) {
      return '';
    }
    const c = this.quoteService.formData?.customer ?? this.customer;
    return Boolean(c?.feriaCustomer) ? 'Sí' : 'No';
  }
}
